// Theme configuration
// Set REACT_APP_THEME environment variable to switch themes
// Available themes: 'maersk', 'ritech', 'firestone' (default)

// Import theme-specific logos
// Logos are stored in src/assets/logos/themes/{theme-name}/
import firestoneLogo from 'assets/logos/themes/firestone/logo.svg';
import firestoneLogoInverse from 'assets/logos/themes/firestone/logo-inverse.svg';
import maerskLogo from 'assets/logos/themes/maersk/logo.svg';
import maerskLogoInverse from 'assets/logos/themes/maersk/logo-inverse.svg';
import ritechLogo from 'assets/logos/themes/ritech/logo.svg';
import ritechLogoInverse from 'assets/logos/themes/ritech/logo-inverse.svg';

// Fallback to default logos if theme-specific logos don't exist
import defaultLogo from 'assets/logo.svg';
import defaultLogoInverse from 'assets/logo-inverse.svg';

const themes = {
  maersk: {
    name: 'Maersk',
    primaryColor: '#42B0D5', // Blue
    btcColor: '#42B0D5',
    btcTextColor: '#F0FDFF',
    btcLogoInverse: true,
    logo: maerskLogo || defaultLogo,
    logoInverse: maerskLogoInverse || defaultLogoInverse,
    companyName: 'Maersk LMS',
    favicon: '/favicons/themes/maersk/favicon.svg',
    faviconIco: '/favicons/themes/maersk/favicon.ico',
  },
  ritech: {
    name: 'Ritech',
    primaryColor: '#000000', // Black
    btcColor: '#F5F5F5',
    btcTextColor: '#000000',
    btcLogoInverse: false,
    logo: ritechLogo || defaultLogo,
    logoInverse: ritechLogoInverse || defaultLogoInverse,
    companyName: 'Ritech Firestone',
    favicon: '/favicons/themes/ritech/favicon.svg',
    faviconIco: '/favicons/themes/ritech/favicon.ico',
  },
  firestone: {
    name: 'Firestone',
    primaryColor: '#42B0D5', // Blue (same as maersk for now)
    btcColor: '#42B0D5',
    btcTextColor: '#F0FDFF',
    btcLogoInverse: true,
    logo: firestoneLogo || defaultLogo,
    logoInverse: firestoneLogoInverse || defaultLogoInverse,
    companyName: 'Firestone',
    favicon: '/favicons/themes/firestone/favicon.svg',
    faviconIco: '/favicons/themes/firestone/favicon.ico',
  },
};

// Get theme from environment variable, default to 'firestone'
const themeName = process.env.REACT_APP_THEME || 'firestone';
const theme = themes[themeName] || themes.firestone;

export default theme;
export { themes };
